jQuery("#back-top").hide();
jQuery(function () {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 1000) {
            jQuery('#back-top').fadeIn();
            jQuery("#back-top").addClass('active');
        } else {
            jQuery('#back-top').fadeOut();
            jQuery("#back-top").removeClass('active');
        }
    });
    jQuery('#back-top').click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 1000);
        return false;
    });
});


window.onscroll = function () {
    myFunction()
};
var banner = document.getElementById("banner");
var header = document.getElementById("headerNav");
if (banner != null) {
    var sticky = banner.offsetHeight - 32;
}
function myFunction() {
    if (window.pageYOffset > sticky) {
        header.classList.add("nav-theme");

    } else {
        header.classList.remove("nav-theme");
    }
}
/**********************footer menu ********************** */

jQuery(document).on("click", ".collapse-menu h4", function (e) {
    jQuery(this).parents(".collapse-menu").find(".menu-collapse-wrap").slideToggle("slow");
    jQuery(this).parents(".collapse-menu").toggleClass("menushow");
});



function lazyloader() {
    const lazyContent = new LazyLoad({
        elements_selector: ".lazy"
    });

    const lazyBackground = new LazyLoad({
        elements_selector: "iframe.lazy, video.lazy, div.lazy, section.lazy, button.lazy,header.lazy"
    });
}


$(document).ready(function () {
    lazyloader();

    $('#toggleMenu').on('click', function () {
        $('.primary-menu-wrapper').toggleClass('openmenu');
        $('.header-navigation').toggleClass('open-menu');
    });

    $('.menuCloseIcon').on('click', function () {
        $('.primary-menu-wrapper').removeClass('openmenu');
        $('.header-navigation').removeClass('open-menu');
    });


    // Background scale animation

    const $banner = $('.home_banner_inner');
    if ($banner.length) {
        setTimeout(function () {
            $banner.addClass('bg-normal');
        }, 400);
    }

    // Trees slide + fade out
    const $leftTree = $('.banner_animations_left');
    const $rightTree = $('.banner_animations_right');

    setTimeout(function () {
        $leftTree.addClass('slide-hide');
        $rightTree.addClass('slide-hide');
    }, 400); // delay before trees start moving



    $('.features-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        variableWidth: true,
        dots: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 568,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $('.reviews-slider-left').slick({
        slidesToShow: 1.9,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        arrows: false,
        vertical: true,
        verticalSwiping: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        swipeToSlide: true,
        touchThreshold: 100,
        pauseOnHover: false,
        pauseOnFocus: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $('.reviews-slider-right').slick({
        slidesToShow: 1.5,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        vertical: true,
        verticalSwiping: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 8000,
        cssEase: 'linear',
        focusOnSelect: false,
        arrows: false,
        swipeToSlide: true,
        touchThreshold: 100,
        pauseOnHover: false,
        pauseOnFocus: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $('.services-slider').slick({
        slidesToShow: 3,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        dots: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    if (window.innerWidth < 992) {
        $('.mobile-slider').slick({
            slidesToShow: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            cssEase: 'linear',
            variableWidth: true,
        });
    }

    $('.filter-btn').on('click', function () {
        $('.filter-btn').removeClass('active');
        $(this).toggleClass('active');
        var range = $(this).data('range');

        // If "All" is selected, show all items
        if (range.toLowerCase() === 'all') {
            $('.area-items').show();
        } else {
            var parts = range.split('-');
            var startChar = parts[0].charCodeAt(0);
            var endChar = parts[1].charCodeAt(0);

            $('.area-items').each(function () {
                var itemChar = $(this).data('char').toUpperCase().charCodeAt(0);
                if (itemChar >= startChar && itemChar <= endChar) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        }
    });

    $(document).on('click', '.menu-collapse-container .collapse-menu-title', function () {
        $(this).parents('.menu-collapse-container').find('.menu-collapse-wrap').slideToggle();
        $(this).find('svg').toggleClass('rotate-180');
    });


});